import { Pagination } from "@mantine/core";
import styled from "styled-components";

const CustomPagination = ({ total, value, onChange, ...rest }: any) => {
  return (
    <Wrapper>
      <Pagination
        total={total}
        value={value}
        onChange={onChange}
        withEdges
        color="#5C26FF"
        radius="xl"
        {...rest}
      />
    </Wrapper>
  );
};

export default CustomPagination;

const Wrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 8px;
`;